import type { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  accentColor?: string;
  onClick?: () => void;
}

export function Card({ children, className = '', accentColor, onClick }: CardProps) {
  return (
    <div
      className={`bg-white border border-[#DDDDDD] rounded-2xl p-5 ${
        accentColor ? 'border-l-4' : ''
      } ${onClick ? 'cursor-pointer hover:shadow-md transition-shadow' : ''} ${className}`}
      style={accentColor ? { borderLeftColor: accentColor } : undefined}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {children}
    </div>
  );
}
